<template>
    <li>
        <div class="callout">
            <div class="callout-img">
                <picture>
                    <source :data-srcset="`${staticAssetPath}/img/${assetFolder}/${calloutImgNameJP2}`" type="image/jp2">
                    <source :data-srcset="`${staticAssetPath}/img/${assetFolder}/${calloutImgNameWebp}`" type="image/webp">
                    <img class="lazyload" :alt="`${alternativeText}`" border="0" :data-src="`${staticAssetPath}/img/${assetFolder}/${calloutImgName}`" />
                </picture>
                
            </div>
            <div class="callout-text" v-html="calloutText"></div>
        </div>
    </li>
</template>

<script>
export default {
  name: 'StandardListItemCallout',
  data () {
        return {
          staticAssetPath: process.env.VUE_APP_BASE_URL + process.env.VUE_APP_ASSETS_URL,
        }
    },
  props: {
    assetFolder: {
        type: String,
        default: '',
    },
    calloutImgName: {
        type: String,
        default: ''
    },
    calloutImgNameWebp: {
        type: String,
        default: ''
    },
    calloutImgNameJP2: {
        type: String,
        default: ''
    },
    calloutText: {
        type: String,
        default: ''
    },
    alternativeText: {
        type: String,
        default: ''
    }
    
  }
}
</script>